module.exports = __webpack_public_path__ + "static/media/1-pak.ab3fd6bc.png";